var _mask, _path, _mask2, _path2, _path3, _mask3, _path4, _path5, _mask4, _path6, _path7, _path8, _path9, _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNhnSolutionLine6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 129,
    viewBox: "0 0 129 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_2137_20280",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1436 23.8828C14.4928 23.8828 10.7226 27.653 10.7226 32.3039V94.0243H5.79492V104.9H65.1429V94.0243H60.2135V32.3039C60.2135 27.653 56.4433 23.8828 51.7925 23.8828H19.1436Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7226 94.0243V95.0243H11.7226V94.0243H10.7226ZM5.79492 94.0243V93.0243H4.79492V94.0243H5.79492ZM5.79492 104.9H4.79492V105.9H5.79492V104.9ZM65.1429 104.9V105.9H66.1429V104.9H65.1429ZM65.1429 94.0243H66.1429V93.0243H65.1429V94.0243ZM60.2135 94.0243H59.2135V95.0243H60.2135V94.0243ZM11.7226 32.3039C11.7226 28.2053 15.0451 24.8828 19.1436 24.8828V22.8828C13.9405 22.8828 9.72255 27.1008 9.72255 32.3039H11.7226ZM11.7226 94.0243V32.3039H9.72255V94.0243H11.7226ZM5.79492 95.0243H10.7226V93.0243H5.79492V95.0243ZM6.79492 104.9V94.0243H4.79492V104.9H6.79492ZM65.1429 103.9H5.79492V105.9H65.1429V103.9ZM64.1429 94.0243V104.9H66.1429V94.0243H64.1429ZM60.2135 95.0243H65.1429V93.0243H60.2135V95.0243ZM59.2135 32.3039V94.0243H61.2135V32.3039H59.2135ZM51.7925 24.8828C55.891 24.8828 59.2135 28.2053 59.2135 32.3039H61.2135C61.2135 27.1008 56.9956 22.8828 51.7925 22.8828V24.8828ZM19.1436 24.8828H51.7925V22.8828H19.1436V24.8828Z",
    fill: "white",
    mask: "url(#path-1-inside-1_2137_20280)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-2_2137_20280",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.7009 23.8823C46.05 23.8823 42.2798 27.6526 42.2798 32.3034V94.0238H34.043V104.899H81.3442V94.0238H72.8V32.3034C72.8 27.6526 69.0298 23.8823 64.3789 23.8823H50.7009Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.7009 23.8823C46.05 23.8823 42.2798 27.6526 42.2798 32.3034V94.0238H34.043V104.899H81.3442V94.0238H72.8V32.3034C72.8 27.6526 69.0298 23.8823 64.3789 23.8823H50.7009Z",
    fill: "#385FAD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2798 94.0238V95.0238H43.2798V94.0238H42.2798ZM34.043 94.0238V93.0238H33.043V94.0238H34.043ZM34.043 104.899H33.043V105.899H34.043V104.899ZM81.3442 104.899V105.899H82.3442V104.899H81.3442ZM81.3442 94.0238H82.3442V93.0238H81.3442V94.0238ZM72.8 94.0238H71.8V95.0238H72.8V94.0238ZM43.2798 32.3034C43.2798 28.2048 46.6023 24.8823 50.7009 24.8823V22.8823C45.4978 22.8823 41.2798 27.1003 41.2798 32.3034H43.2798ZM43.2798 94.0238V32.3034H41.2798V94.0238H43.2798ZM34.043 95.0238H42.2798V93.0238H34.043V95.0238ZM35.043 104.899V94.0238H33.043V104.899H35.043ZM81.3442 103.899H34.043V105.899H81.3442V103.899ZM80.3442 94.0238V104.899H82.3442V94.0238H80.3442ZM72.8 95.0238H81.3442V93.0238H72.8V95.0238ZM71.8 32.3034V94.0238H73.8V32.3034H71.8ZM64.3789 24.8823C68.4775 24.8823 71.8 28.2048 71.8 32.3034H73.8C73.8 27.1003 69.582 22.8823 64.3789 22.8823V24.8823ZM50.7009 24.8823H64.3789V22.8823H50.7009V24.8823Z",
    fill: "white",
    mask: "url(#path-3-inside-2_2137_20280)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-3_2137_20280",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.1065 40.4746C56.4557 40.4746 52.6854 44.2449 52.6854 48.8957V96.2509H47.7578V104.899H107.106V96.2509H102.176V48.8957C102.176 44.2448 98.4062 40.4746 93.7554 40.4746H61.1065Z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.1065 40.4746C56.4557 40.4746 52.6854 44.2449 52.6854 48.8957V96.2509H47.7578V104.899H107.106V96.2509H102.176V48.8957C102.176 44.2448 98.4062 40.4746 93.7554 40.4746H61.1065Z",
    fill: "#385FAD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6854 96.2509V97.2509H53.6854V96.2509H52.6854ZM47.7578 96.2509V95.2509H46.7578V96.2509H47.7578ZM47.7578 104.899H46.7578V105.899H47.7578V104.899ZM107.106 104.899V105.899H108.106V104.899H107.106ZM107.106 96.2509H108.106V95.2509H107.106V96.2509ZM102.176 96.2509H101.176V97.2509H102.176V96.2509ZM53.6854 48.8957C53.6854 44.7971 57.008 41.4746 61.1065 41.4746V39.4746C55.9034 39.4746 51.6854 43.6926 51.6854 48.8957H53.6854ZM53.6854 96.2509V48.8957H51.6854V96.2509H53.6854ZM47.7578 97.2509H52.6854V95.2509H47.7578V97.2509ZM48.7578 104.899V96.2509H46.7578V104.899H48.7578ZM107.106 103.899H47.7578V105.899H107.106V103.899ZM106.106 96.2509V104.899H108.106V96.2509H106.106ZM102.176 97.2509H107.106V95.2509H102.176V97.2509ZM101.176 48.8957V96.2509H103.176V48.8957H101.176ZM93.7554 41.4746C97.8539 41.4746 101.176 44.7971 101.176 48.8957H103.176C103.176 43.6926 98.9585 39.4746 93.7554 39.4746V41.4746ZM61.1065 41.4746H93.7554V39.4746H61.1065V41.4746Z",
    fill: "white",
    mask: "url(#path-5-inside-3_2137_20280)"
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "path-7-inside-4_2137_20280",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.6716 40.4746C88.0207 40.4746 84.2505 44.2449 84.2505 48.8957V96.2509H76.0137V104.899H123.315V96.2509H114.771V48.8957C114.771 44.2448 111 40.4746 106.35 40.4746H92.6716Z"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.6716 40.4746C88.0207 40.4746 84.2505 44.2449 84.2505 48.8957V96.2509H76.0137V104.899H123.315V96.2509H114.771V48.8957C114.771 44.2448 111 40.4746 106.35 40.4746H92.6716Z",
    fill: "#385FAD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M84.2505 96.2509V97.2509H85.2505V96.2509H84.2505ZM76.0137 96.2509V95.2509H75.0137V96.2509H76.0137ZM76.0137 104.899H75.0137V105.899H76.0137V104.899ZM123.315 104.899V105.899H124.315V104.899H123.315ZM123.315 96.2509H124.315V95.2509H123.315V96.2509ZM114.771 96.2509H113.771V97.2509H114.771V96.2509ZM85.2505 48.8957C85.2505 44.7971 88.573 41.4746 92.6716 41.4746V39.4746C87.4685 39.4746 83.2505 43.6926 83.2505 48.8957H85.2505ZM85.2505 96.2509V48.8957H83.2505V96.2509H85.2505ZM76.0137 97.2509H84.2505V95.2509H76.0137V97.2509ZM77.0137 104.899V96.2509H75.0137V104.899H77.0137ZM123.315 103.899H76.0137V105.899H123.315V103.899ZM122.315 96.2509V104.899H124.315V96.2509H122.315ZM114.771 97.2509H123.315V95.2509H114.771V97.2509ZM113.771 48.8957V96.2509H115.771V48.8957H113.771ZM106.35 41.4746C110.448 41.4746 113.771 44.7971 113.771 48.8957H115.771C115.771 43.6926 111.553 39.4746 106.35 39.4746V41.4746ZM92.6716 41.4746H106.35V39.4746H92.6716V41.4746Z",
    fill: "white",
    mask: "url(#path-7-inside-4_2137_20280)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0289 77.1145V93.597H60.2832V77.1145C60.2832 73.3188 63.3603 70.2417 67.1561 70.2417C70.9518 70.2417 74.0289 73.3188 74.0289 77.1145Z",
    stroke: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M32.066 77.1145V93.597H18.3203V77.1145C18.3203 73.3188 21.3974 70.2417 25.1932 70.2417C28.9889 70.2417 32.066 73.3188 32.066 77.1145Z",
    stroke: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 57.4121,
    y: 48.8979,
    width: 4.74316,
    height: 4.75,
    rx: 2.37158,
    fill: "white",
    stroke: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 65.0527,
    y: 48.8979,
    width: 4.74316,
    height: 4.75,
    rx: 2.37158,
    fill: "white",
    stroke: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 15.4414,
    y: 31.9004,
    width: 4.74316,
    height: 4.75,
    rx: 2.37158,
    fill: "white",
    stroke: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 23.082,
    y: 31.9004,
    width: 4.74316,
    height: 4.75,
    rx: 2.37158,
    fill: "white",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNhnSolutionLine6);
export default __webpack_public_path__ + "static/media/nhnSolutionLine6.9fb78c98f397f0224281cc79d4402d55.svg";
export { ForwardRef as ReactComponent };